import { render, staticRenderFns } from "./ReportSuggestion.vue?vue&type=template&id=4e7340a9&scoped=true"
import script from "../js/Reports/suggestion.js?vue&type=script&lang=js&external"
export * from "../js/Reports/suggestion.js?vue&type=script&lang=js&external"
import style0 from "./ReportSuggestion.vue?vue&type=style&index=0&id=4e7340a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7340a9",
  null
  
)

export default component.exports